// adding scripts
import { Injectable } from '@angular/core';

const myScripts = [
  {
    name: 'barraGov',
    src: 'https://barra.brasil.gov.br/barra_2.0.js',
  },
  {
    name: 'reCaptcha',
    src: 'https://www.google.com/recaptcha/api.js',
  },
];

@Injectable({ providedIn: 'root' })
export class ScriptsService {
  private scripts: any = {};

  constructor() {
    myScripts.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
  }

  // load a single or multiple scripts
  load(...scripts: string[]): Promise<any> {
    const promises: any[] = [];

    // push the returned promise of each loadScript call
    scripts.forEach((script) => promises.push(this.loadScript(script)));

    // return promise.all that resolves when all promises are resolved
    return Promise.all(promises);
  }

  loadScript(name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // resolve if alredy loaded
      if (this.scripts[name].loaded) {
        resolve({
          script: name,
          loaded: true,
          status: 'Alredy Loaded',
        });
      } else {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        script.defer = true;

        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };

        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });

        // finally append the script tag in the DOM
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}
